import { render } from "./mediterraneo.vue?vue&type=template&id=0e25b382&bindings={\"navigate\":\"props\"}"
import script from "./mediterraneo.vue?vue&type=script&lang=js"
export * from "./mediterraneo.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./mediterraneo.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script